module.exports = __webpack_public_path__ + "static/media/emma-stone-lose.bab23874.jpg";